import useLocalStorage from "utilities/hooks/use-local-storage";
const LOCAL_STORAGE_KEY_LAST_VISITED_NOTEBOOK_ID = "lastVisitedNotebookId";

const useLastVisitedNotebook = () => {
    const {
        storedValue: lastVisitedNotebookId,
        setValue: setLastVisitedNotebookId,
    } = useLocalStorage<number | undefined>(
        LOCAL_STORAGE_KEY_LAST_VISITED_NOTEBOOK_ID,
        undefined
    );

    return {
        lastVisitedNotebookId,
        setLastVisitedNotebookId,
    };
};

export default useLastVisitedNotebook;
